/**
 * @module hooks/useStationsInfo
 * @author Charles Blais <charles.blais@canada.ca>
 *
 * Get stations information
 */
import { AxiosError } from 'axios';

import useAxios from 'axios-hooks';

import { useState, useEffect } from 'react';

import { StationsInfo } from '../typings/waveform-plot';


type Props = {
  initialUrl: string,
}

type ReturnProps = {
  stations: StationsInfo,
  loading: Boolean,
  error: AxiosError<any, any> | null,
  setUrl: (value: string) => void,
}


/**
 * React Hook
 * ==========
 *
 * Get waveform cache stations information
 */
const useStationsInfo = ({
  initialUrl,
}: Props): ReturnProps => {
  const [ url, setUrl ] = useState(initialUrl);

  const [{ data: stations, loading, error }, fetch] = useAxios({
    url
  }, {
    manual: url.length === 0
  });

  useEffect(() => {
    if(url.length !== 0) fetch({url})
  }, [fetch, url])

  return { stations, loading, error, setUrl };
};

export default useStationsInfo;
